export default "__VITE_ASSET__3bc571a7__"